<template>
    <div class="dropdown">
        <a id="navbarServiceAccountDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <template v-if="!selectedServiceAccountName && haveServiceAccount">
                <span class="fa fa-refresh fa-spin"></span> Loading...
            </template>
            <template v-else-if="!selectedServiceAccountName && !haveServiceAccount">
                <span class="fa fa-ban"></span> {{ $t('words.has_not_service_account') }}
            </template>
            <template v-else>
                <i class="icon icon-sm icon-user"></i>{{ selectedServiceAccountName }}
            </template>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarServiceAccountDropdown">
            <!--<router-link class="dropdown-item" :to="{ name: 'cms-creator-channel-view' }">-->
                <!--<i class="icon icon-setting"></i>{{ getLoginAccount.name }} ({{ getLoginAccountRole }})-->
            <!--</router-link>-->
            <a class="dropdown-item" href="/creator/logout"
               onclick="event.preventDefault(); document.getElementById('logout-form').submit();"><i class="icon icon-logout"></i>{{ $t('words.logout') }}
            </a>
            <form id="logout-form" action="/creator/logout" method="POST" style="display: none;">
                <input type="hidden" name="_token" :value="csrf_token" />
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'service-account-bar',
    data() {
        return {
            csrf_token: null,
        };
    },
    mounted() {
        const token = document.head.querySelector('meta[name="csrf-token"]');

        this.csrf_token = token.getAttribute('content');
    },
    computed: {
        ...mapGetters([
            'selectedServiceAccount',
            'getServiceAccounts',
            'getLoginAccount',
            'haveServiceAccount',
            'getLoginAccountRole',
        ]),
        selectedServiceAccountName() {
            return typeof this.selectedServiceAccount === 'undefined' ? null : this.selectedServiceAccount.name;
        },
    },
};
</script>

<style scoped>
    .dropdown-menu-right {
        top: auto !important;
        left: auto !important;
        right: 0 !important;
        transform: none !important;
    }
</style>
